import type { ReactNode } from "react";

export const adminInputClasses =
  "h-10 rounded-control border border-border-strong bg-surface px-3 text-[13px] font-medium text-ink outline-none transition-colors placeholder:text-ink-subtle hover:border-border-strong focus:border-info";

export const adminSelectClasses =
  "h-10 rounded-control border border-border-strong bg-surface px-3 text-[13px] font-semibold text-ink outline-none transition-colors hover:border-border-strong focus:border-info";

export function AdminPanel({
  children,
  className = "",
}: {
  readonly children: ReactNode;
  readonly className?: string;
}) {
  return (
    <section
      className={`rounded-panel border border-border bg-surface ${className}`}
    >
      {children}
    </section>
  );
}

export function AdminStatCard({
  label,
  onClick,
  value,
}: {
  readonly label: string;
  readonly onClick?: () => void;
  readonly value: ReactNode;
}) {
  const interactiveClasses = onClick
    ? "cursor-pointer transition-colors hover:border-info hover:bg-surface-hover"
    : "";
  return (
    <div
      className={interactiveClasses}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <AdminPanel className="p-[18px]">
        <div className="text-xs font-bold text-ink-muted">{label}</div>
        <div className="mt-1.5 text-[28px] font-extrabold leading-tight text-ink">
          {value}
        </div>
      </AdminPanel>
    </div>
  );
}

export function AdminSectionTitle({
  children,
  className = "",
}: {
  readonly children: ReactNode;
  readonly className?: string;
}) {
  return (
    <h2 className={`mb-2.5 text-[15px] font-extrabold text-ink ${className}`}>
      {children}
    </h2>
  );
}

export function AdminMiniList({
  children,
  className = "",
}: {
  readonly children: ReactNode;
  readonly className?: string;
}) {
  return <div className={`flex flex-col gap-2 ${className}`}>{children}</div>;
}

export function AdminMiniRow({
  children,
  className = "",
}: {
  readonly children: ReactNode;
  readonly className?: string;
}) {
  return (
    <div
      className={`flex items-center justify-between gap-3 rounded-control border border-border bg-surface px-3 py-2.5 text-[13px] ${className}`}
    >
      {children}
    </div>
  );
}

export function AdminTableToolbar({
  children,
}: {
  readonly children: ReactNode;
}) {
  return (
    <div className="flex w-full flex-wrap items-center justify-between gap-3">
      {children}
    </div>
  );
}
